export type PackingSuppliesEdges = {
  HOME: string;
};

export type PackingSuppliesEdgesProp = Partial<PackingSuppliesEdges>;

export type PackingSuppliesData = {
  moveId: string;
  homeSize: string;
  packingKit: string;
};

export enum PackingSuppliesExperiments {
  CARD_EXPERIMENT = 'ms_pod_boxes',
  INTRO_PAGE_EXPERIMENT = 'ml_pod_psintro',
  ENTRY_POINT_EXPERIMENT = 'ms_boxes_v2',
  STARTER_KIT_EXPERIMENT = 'ms_boxes_starterkit'
}

export enum PackingSuppliesVariations {
  CONTROL = 'control',
  VARIATION_2 = 'ps_large_card',
  VARIATION_3 = 'ps_large_card_section',
  VARIATION_4 = 'small_card',
}

export enum IntroPageVariation {
  CONTROL = 'control',
  VARIATION_1 = 'intro_page',
}

export enum EntryPointVariation {
  CONTROL = 'control',
  VARIATION_1 = 'ps_large_tvi',
  VARIATION_2 = 'ps_large_last',
}

export enum StarterKitVariation {
  CONTROL = 'control',
  VARIATION_1 = 'starter_kit',
}
